import { firebaseFunctions } from "./firebaseApp";
import { httpsCallable } from "firebase/functions";

/*
 * Fetch the consent and withdrawal copy the checkout must show, for one locale.
 *
 * The server publishes the wording together with the version and content hash
 * it will later be checked against, so this is the ONLY place the checkout may
 * get that text from. Reading it from a constant in this bundle would produce
 * a hash the server rejects the moment the copy is revised — and, far worse,
 * could produce one it accepts for text the buyer never saw.
 *
 * Errors are left to propagate. An unsupported locale and a network failure
 * need different words in front of the buyer, and the caller is the only thing
 * that knows which surface is asking.
 */
export const getConsentCopy = async (locale) => {
  const consentCopy = httpsCallable(firebaseFunctions, "getConsentCopy");
  const ret = await consentCopy({ locale });
  return ret.data;
};
